module.exports = __webpack_public_path__ + "img/Session.3fe18f58.svg";